import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage, GetPickerCss } from '../../../../services/helpers.js';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import ModifiedByInfo from "./../../../Common/Footers/ModifiedByInfo";
import moment from 'moment';
import { SketchPicker } from 'react-color';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import appFetch from '../../../../api/appFetch.js';
import { TagsUrl, TagsWithIdUrl } from '../../../../constants/apiUrls.js';
import EnhancedDropdownComponent from '../../../Common/Dropdowns/EnhancedDropdownComponent.js';
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';

export default class TagCreation extends Component {
  constructor(props) {
    super(props);
    let editedTag = undefined;
    let outletId = 0;
    let type = 3;
    let editedTagId = 0;
    let id = 0;

    if (this.props.location !== undefined && this.props.location.state !== undefined) {
      editedTag = this.props.location.state.editedTag;
      editedTagId = this.props.location.state.tagId;
      id = parseInt(this.props.tagId);
    }
    else if (this.props !== undefined) {
      outletId = this.props.outletId;
      if (this.props.type !== undefined) type = this.props.type;
      if (this.props.tagId !== undefined) id = parseInt(this.props.tagId);
    }

    this.state = {
      id: id,
      type: type,
      description: "",
      outletId: outletId,
      isPause: false,
      isVisibleInPlanning: this.props.isVisibleInPlanning,
      color: "#FFFFFF",
      modifiedByAvatar: "",
      modifiedByName: "",
      modifiedOn: "",
      editedTag: editedTag,
      editedTagId: editedTagId,
      loading: this.props.editedTagId !== undefined,
      redirect: false,
      accessibleMoboOutlets: [],
      requestInProgress: false,
      redirect: null,
      open: true,
      tagWasCreated: false,
      displayColorPicker: false,
    };
  }

  componentDidMount() {
    if (this.props.location !== undefined && this.props.location.state !== undefined && this.props.location.state.editedTag !== undefined) {
      this.getEditegTagDetails(this.props.location.state.editedTag);
    } else if (this.state.id != undefined && this.state.id > 0) {
      this.getTagDetails();
    }
  }

  handleClose = () => {
    this.setState({ open: false, redirect: "/tags", type: this.state.type, outletId: this.state.outletId });
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, "") });
  };

  handleTypeChange = e => {
    this.setState({ [e.target.name]: parseInt(e.target.value) });
  };

  handleChangeCheckBox = e => {
    this.setState({ [e.target.name]: e.target.checked });
  };

  handleClickColorPicker = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  };

  handleCloseColorPicker = () => {
    this.setState({ displayColorPicker: false })
  };

  handleChangeColorPicker = (color) => {
    this.setState({ color: color.hex })
  };

  handleKeyUp = e => {
    this.setState({ [e.target.name]: e.target.value })
  };

  handleChangeOutlet = e => {
    this.setState({ outletId: parseInt(e.target.value) });
  };

  isValidForm = () => {
    const { description, type, outletId } = this.state;

    if (!description || description.trim().length === 0) {
      return false;
    }

    if (!type || type === 0) {
      return false;
    }

    if (outletId < 0) {
      return false;
    }

    return true;
  }

  handleSaveTag = () => {
    if (this.state.id == 0) {
      this.saveNewtag();
    }
    else {
      this.saveEditedTag();
    }
  }

  saveNewtag = () => {
    let resources = this.props.resources;

    if (!this.isValidForm()) {
      return;
    }

    this.setState({ requestInProgress: true });

    var json = JSON.stringify({
      type: this.state.type,
      moboOutletId: this.state.outletId > 0 ? this.state.outletId : null,
      colorHex: this.state.color.replace("#", ""),
      description: this.state.description,
      isPause: this.state.isPause,
      isVisibleInPlanning: this.state.isVisibleInPlanning
    });

    appFetch({
      url: TagsUrl(),
      method: 'POST',
      body: json,
      onSuccess: (data) => {
        DisplayMessage(resources["NewTagWasSaved"], "success");
        this.setState({ tagWasCreated: true, redirect: "/tags" });
      },
      onError: (data) => {
        for (let i = 0; i < data.errors.length; i++) {
          DisplayMessage(data.errors[i], "error");
        }
      },
      onFinalize: () => {
        this.setState({ requestInProgress: false });
      }
    })
  }

  saveEditedTag = () => {
    let resources = this.props.resources;

    if (!this.isValidForm()) {
      return;
    }

    this.setState({ requestInProgress: true });

    var json = JSON.stringify({
      colorHex: this.state.color.replace("#", ""),
      description: this.state.description,
      isPause: this.state.isPause,
      isVisibleInPlanning: this.state.isVisibleInPlanning
    });

    appFetch({
      url: TagsWithIdUrl(this.state.id),
      method: 'PUT',
      body: json,
      onSuccess: (data) => {
        DisplayMessage(resources["TagEditedSuccessfully"], "success");
        this.setState({ tagWasCreated: true, redirect: "/tags" });
      },
      onError: (data) => {
        for (let i = 0; i < data.errors.length; i++) {
          DisplayMessage(data.errors[i], "error");
        }
      },
      onFinalize: () => {
        this.setState({ requestInProgress: false });
      }
    })
  }

  getTagDetails = () => {
    const { id } = this.state;
    this.setState({ requestInProgress: true });

    let url = TagsUrl();

    appFetch({
      url: url,
      onSuccess: (data) => {
        var existsTag = false;
        var editedTag = undefined;

        data.forEach(function (row) {

          if (row.id === id) {
            existsTag = true;
            editedTag = row;
          }
        });

        if (existsTag) {
          this.setState({
            id: editedTag.id,
            type: editedTag.type,
            description: editedTag.description,
            outletId: editedTag.moboOutletId,
            isPause: editedTag.isPause,
            color: "#" + editedTag.colorHex,
            modifiedOn: editedTag.modifiedOn,
            modifiedByAvatar: editedTag.modifiedByAvatar,
            modifiedByName: editedTag.modifiedByName,
            requestInProgress: false,
            isVisibleInPlanning: editedTag.isVisibleInPlanning
          });
        } else {
          this.setState({ open: false, redirect: "/tags" });
        }
      },
      onError: (data) => {
      },
      onFinalize: () => {
        this.setState({ requestInProgress: false });
      }
    })
  }

  getEditegTagDetails = (editedTag) => {
    this.setState({
      id: editedTag.id,
      type: editedTag.type,
      description: editedTag.description,
      outletId: editedTag.moboOutletId,
      isPause: editedTag.isPause,
      color: "#" + editedTag.colorHex,
      modifiedOn: editedTag.modifiedOn,
      modifiedByAvatar: editedTag.modifiedByAvatar,
      modifiedByName: editedTag.modifiedByName,
      requestInProgress: false,
      isVisibleInPlanning: editedTag.isVisibleInPlanning
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.handleSaveTag();
  };

  renderModifiedByInfo = () => {
    if (this.state.id > 0) {
      return (
        <ModifiedByInfo
          resources={this.props.resources}
          modifiedByAvatar={this.state.modifiedByAvatar}
          modifiedOn={this.state.modifiedOn}
          modifiedByName={this.state.modifiedByName}
          className="mt-3"
        />
      );
    }

    return;
  }

  renderForm() {
    const { description, isPause, outletId, type, isVisibleInPlanning } = this.state;

    var resources = this.props.resources;
    var helperTextDescription = description.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";
    const styles = GetPickerCss(this.state.color);

    return (
      <div>
        <Paper elevation={3} className="p-4 mt-3 mb-3">
          <Form onSubmit={this.handleSubmit} >
            <Form.Group className="d-flex">
              <div className="col-3"></div>
              <div className="col-md-6 helper-text-red" style={{ padding: 0 }}>
                <EnhancedDropdownComponent
                  id="type-dropdown"
                  labelText={resources["Type"]}
                  value={type}
                  options={[
                    { key: 3, name: resources["Dossiers"] },
                    { key: 4, name: resources["RepairOrderItems"] },
                    { key: 5, name: resources["Warranty"] },
                  ]}
                  inputName="type"
                  handleChange={this.handleTypeChange}
                  addMarginBottom={false}
                  disabled={this.state.id > 0}
                />
              </div>
              <div className="col-3"></div>
            </Form.Group>

            <Form.Group className="pt-3" style={{ display: "flex" }}>
              <div className="col-3"></div>
              <ThemeProvider theme={SelectTheme}>
                <TextField className={"col-6 " + helperTextDescription} id="tag-description" label={resources["Description"]}
                  helperText={resources["InputOfDescriptionIsMandatory"]} value={description}
                  variant="outlined" name="description" onChange={this.handleChange} onKeyUp={this.handleKeyUp} inputProps={{ maxLength: 25 }} />
              </ThemeProvider >
            </Form.Group>

            <Form.Group className="d-flex" >
              <div className="col-3"></div>
              <OutletsDropdown
                resources={resources}
                outlets={this.props.accessibleMoboOutlets}
                outlet={outletId ?? 0}
                onOutletChange={this.handleChangeOutlet}
                containerClass="col-md-6 helper-text-red"
                disabled={this.state.id > 0}
              />
              <div className="col-3"></div>
            </Form.Group>
            <Form.Group style={{ display: "flex" }} >
              <div className="col-md-3 "> </div>
              <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                control={<Checkbox id="tag-is-pause" checked={isPause} onChange={this.handleChangeCheckBox} name="isPause" color="primary" />}
                label={resources["IsPause"]} />
              <div className="col-md-4"> </div>
            </Form.Group>

            {type === 3 ? (<Form.Group style={{ display: "flex" }} >
              <div className="col-md-3 "> </div>
              <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                control={<Checkbox id="tag-is-visible-in-planning" checked={isVisibleInPlanning} onChange={this.handleChangeCheckBox} name="isVisibleInPlanning" color="primary" />}
                label={resources["IsVisibleInPlanning"]} />
              <div className="col-md-4"> </div>
            </Form.Group>) : ""}

            <Form.Group style={{ display: "flex" }}>
              <div className="col-md-3"></div>
              <div>
                <div style={{ display: "flex" }}>
                  <div style={styles.swatch} onClick={this.handleClickColorPicker}>
                    <div style={styles.color} id="color-picker" />
                  </div>
                  <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1 align-center" style={{ paddingTop: "8px", paddingLeft: "3px" }} >{resources["ColorHex"]}
                    <em className="text-danger">*</em></span>
                </div>
                {this.state.displayColorPicker ? <div style={styles.popover}>
                  <div style={styles.cover} onClick={this.handleCloseColorPicker} />
                  <SketchPicker color={this.state.color} onChange={this.handleChangeColorPicker} />
                </div> : null}
              </div>
            </Form.Group>
            {this.renderModifiedByInfo()}
          </Form>
        </Paper>
      </div >
    );
  }

  renderMain() {
    const { loading } = this.state;

    if (loading) {
      return (<div className="centered-loader"><CircularProgress /></div>);
    }

    return <div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
      {this.renderForm()}
    </div>;
  }

  render() {
    const { redirect, open, tagWasCreated, outletId, id, requestInProgress, type } = this.state;
    const { resources } = this.props;

    const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect

    return (
      <div>
        {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: tagWasCreated, outletId, type } }} delay={250} />}
        <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
          <AppBar className="position-sticky ">
            <Toolbar>
              <IconButton id="close-add-tag" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" style={{ flex: 1 }}>
                {id != undefined && id > 0 ? resources["EditTagTitle"] : resources["AddNewTagTitle"]}
              </Typography>
              <Button id="tag-save" color="inherit" disabled={isSaveButtonDisabled} onClick={this.handleSaveTag}>{resources["Save"]}</Button>
            </Toolbar>
          </AppBar>
          <div className="container">
            {this.renderMain()}
          </div>
        </Dialog>
      </div >
    );
  }
}